// Convert selects to select2 elements
jQuery(document).ready(function ($) {
	const blogSelect = $('#blog-select');
	const caseStudiesSelect = $('#case-studies-select');
	const productCategoriesSelect = $('#product-category-select');
	const videoCategoriesSelect = $('#video-category-select');
	const eventsSelect = $('#events-select');
	const dealersSelect = $('#dealers-select');

	if (blogSelect.length) {
		blogSelect.select2({
			minimumResultsForSearch: Infinity,
		});
	}

	if (caseStudiesSelect.length) {
		caseStudiesSelect.select2({
			minimumResultsForSearch: Infinity,
		});
	}

	if (productCategoriesSelect.length) {
		productCategoriesSelect.select2({
			minimumResultsForSearch: Infinity,
		});
	}

	if (videoCategoriesSelect.length) {
		videoCategoriesSelect.select2({
			minimumResultsForSearch: Infinity,
		});
	}

	if (eventsSelect.length) {
		eventsSelect.select2({
			minimumResultsForSearch: Infinity,
		});
	}

	if (dealersSelect.length) {
		dealersSelect.select2({
			minimumResultsForSearch: Infinity,
		});
	}
});
